/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Avg_Hr_RangeInputs */

const en_exp_avg_hr_range = /** @type {(inputs: Exp_Avg_Hr_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zone 1–2 (easy): 50–70% of max HR. Zone 3 (tempo): 70–80%. Zone 4 (threshold): 80–90%. Zone 5 (VO2max): 90–100%. Actual values depend on individual max HR.`)
};

const de_exp_avg_hr_range = /** @type {(inputs: Exp_Avg_Hr_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zone 1–2 (locker): 50–70% Max-HF. Zone 3 (Tempo): 70–80%. Zone 4 (Schwelle): 80–90%. Zone 5 (VO2max): 90–100%. Die genauen Werte hängen von deiner Max-HF ab.`)
};

/**
* | output |
* | --- |
* | "Zone 1–2 (easy): 50–70% of max HR. Zone 3 (tempo): 70–80%. Zone 4 (threshold): 80–90%. Zone 5 (VO2max): 90–100%. Actual values depend on individual max HR." |
*
* @param {Exp_Avg_Hr_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_avg_hr_range = /** @type {((inputs?: Exp_Avg_Hr_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Avg_Hr_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_avg_hr_range(inputs)
	return de_exp_avg_hr_range(inputs)
});